import Immutable from 'seamless-immutable';
// --- external imports -----

import { getNewEmptyIncomeStatementObj } from '~/models/income-statement';
// ---- internal imports ----

import { getFinancialStatementsFor, getSystemFinancialStatementsFor } from './';
// ---- local imports ----

export function getIncomeStatementFor(state, quarterNum) {
	const financialStatement = getFinancialStatementsFor(state, quarterNum);
	if (financialStatement && financialStatement.incomeStatement) {
		return financialStatement.incomeStatement;
	}
	else {
		return new Immutable(getNewEmptyIncomeStatementObj());
	}
}

export function getSystemIncomeStatementFor(state, quarterNum) {
	const financialStatement = getSystemFinancialStatementsFor(state, quarterNum);
	if (financialStatement && financialStatement.incomeStatement) {
		return financialStatement.incomeStatement;
	}
	else {
		return new Immutable(getNewEmptyIncomeStatementObj());
	}
}

export function getSystemNetProfitFor(state, quarterNum) {
	return getSystemIncomeStatementFor(state, quarterNum).netProfit;
}
